$(function () {
  var $header = $('#head_wrap');
  $('#g-nav, #nav-toggle, #nav-toggle-03, .stelvio-navigation-sticky-next, #g-nav ul li a, #g-nav-sp ul li a').on('click', function () {
    $header.toggleClass('open');
    $('#nav-toggle-02').toggleClass('rotate');
  });
  modelSlide("exterior");
  modelSlide("interior");
  modelSlide("safety");
  /*$.scrollify({
    section:'.scrollify', //対象要素を指定
    easing: 'swing', // イージングを指定
    scrollSpeed: 600, // スクロール時の速度
    updateHash: false, // スクロール時アドレスバーのURLを更新
  });*/
  /*$(function () {
    var scrollStart = $('.stelvio-kv-btn').offset().top; //ページ上部からの距離を取得
    var distance = 0;
    $(document).on("scroll", function () {
      distance = $(this).scrollTop(); //スクロールした距離を取得
      if (scrollStart <= distance) { //スクロール距離が位置を超えたら
        $('.stelvio-navigation-sticky-next-02').addClass('visible'); //class『fixed』を追加
      } else if (scrollStart >= distance) { //スクロールがページ上部まで戻ったら
        $('.stelvio-navigation-sticky-next-02').removeClass('visible'); //class『fixed』を削除
      }
    });
  });*/
  function modelSlide(type) {
    var $slide = $('.js-' + type);
    $(window).on("load resize", function () {
      var imageHeight = $(".js-" + type + "-image").height() + 10;
      $(".js-" + type + "-count").css("top", imageHeight);
    });
    $slide.on('init', function (event, slick) {
      var winWidth = $(window).innerWidth();
      $(this).append('<p class="stelvio-section-slider-count js-' + type + '-count for-sp"><span class="current"></span> / <span class="total"></span></p>');
      $('.current', this).text(slick.currentSlide + 1);
      $('.total', this).text(slick.slideCount);
      if (winWidth >= 768) {
        $(".slick-slide:not(.slick-current)", this).css({
          width: "calc(345/1366*100vw)",
          marginTop: "calc(23/1366*100vw)"
        });
        $(".slick-current", this).css({
          width: "calc(700/1366*100vw)",
          marginTop: 0
        });
        $(".slick-track", this).css("left", "calc((345/1366*100vw) * 0.5 - (16/1366*100vw))");
      }
    });
    if (type != "safety") {
      $slide.not('.slick-initialized').slick({
        dots: false,
        infinite: true,
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        adaptiveHeight: false,
        asNavFor: ".js-" + type + "-text",
        responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
          }
        }, {
          breakpoint: 768,
          settings: {
            centerMode: true,
            slidesToShow: 1,
            arrows: false
          }
        }],
        prevArrow: '<div class="stelvio-section-slider-arrow prev"><svg xmlns="http://www.w3.org/2000/svg" width="13.854" height="22.191" viewBox="0 0 13.854 22.191"><path d="M11.083,0,0,11.083l.012.012L0,11.107,11.083,22.19l2.771-2.771L5.529,11.1,13.854,2.77Z" transform="translate(0 0)"/></svg></div>',
        nextArrow: '<div class="stelvio-section-slider-arrow next"><svg xmlns="http://www.w3.org/2000/svg" width="13.854" height="22.191" viewBox="0 0 13.854 22.191"><path d="M11.083,0,0,11.083l.012.012L0,11.107,11.083,22.19l2.771-2.771L5.529,11.1,13.854,2.77Z" transform="translate(13.854 22.19) rotate(180)"/></svg></div>'
      });
    } else {
      $('.js-safety').not('.slick-initialized').slick({
        dots: false,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: 0,
        slidesToScroll: 1,
        variableWidth: true,
        adaptiveHeight: true,
        responsive: [{
          breakpoint: 9999,
          settings: 'unslick'
        }, {
          breakpoint: 768,
          settings: {
            arrows: false
          }
        }],
      });
    }
    $slide.on('init reInit beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.current', this).text(nextSlide + 1);
      var winWidth = $(window).innerWidth();
      if (winWidth >= 768) {
        $(".slick-slide", this).css({
          width: "calc(345/1366*100vw)",
          marginTop: "calc(23/1366*100vw)"
        });
      }
    });
    $slide.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      var winWidth = $(window).innerWidth();
      if (winWidth >= 768) {
        $(".slick-current", this).css({
          width: "calc(700/1366*100vw)",
          marginTop: 0
        });
        $(".slick-track", this).css("left", "calc((345/1366*100vw) * 0.5 - (16/1366*100vw))");
      }
    });
    $('.js-' + type + "-text").slick({
      dot: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      asNavFor: ".js-" + type,
      responsive: [{
        breakpoint: 768,
        settings: {
          slideToShow: 1,
          centerMode: true,
          centerPadding: 0,
          arrows: false
        }
      }],
    });
  }
  $('.js-product-galleryslick02').slick({
    dots: false,
    speed: 400,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 2000,
      settings: 'unslick'
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10%'
      }
    }],
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });
  $('.js-gallery').slick({
    dots: false,
    infinite: false,
    centerMode: true,
    centerPadding: "25%",
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        centerPadding: 0,
        infinite: true
      }
    }],
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });
});

var elemTop = [];
//現在地を取得するための設定を関数でまとめる
function PositionCheck() {
  //headerの高さを取得
  var headerH = $("#g-nav").outerHeight(true);
  $(".scroll-point").each(function (i) { 
    elemTop[i] = Math.round(parseInt($(this).offset().top-headerH)); 
    var scroll = Math.round($(window).scrollTop());
    var NavElem = $(".stickynav-menulist li"); 
    var NavElemSP = $("#head_wrap .stickynav-menulist li");
    $(".stickynav-menulist li").removeClass('current');
    $("#head_wrap .stickynav-menulist li").removeClass('is-current');
	  if (scroll >= 0 && scroll < elemTop[1]) { 
	    $(NavElem).eq(0).addClass('current');
	    $(NavElemSP).eq(0).addClass('is-current'); 
	  } else if (scroll >= elemTop[1] && scroll < elemTop[2]) {
		$(NavElem).eq(1).addClass('current');
		$(NavElemSP).eq(1).addClass('is-current');
	  }
  });
  
}
// 画面をスクロールをしたら動かしたい場合の記述
$(window).on("scroll", function () {
  PositionCheck(); /* 現在地を取得する関数を呼ぶ*/
});
$(window).on('load resize', function () {
  //リサイズされたときの処理
  PositionCheck()
});